import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const nameSchema = string().label('Name');

export const NameHookFormField = (props: FieldInputProps) => <HookFormField.Input label="Name" {...props}/>;